import type { SVGProps } from 'react'

import { useBoundStore } from '../../store/store'
import { ICON_IDS } from './icon-ids'

export type IconId = (typeof ICON_IDS)[number]

type IconProps = {
  id: IconId
} & SVGProps<SVGSVGElement>

const Icon = ({ id, ...props }: IconProps) => {
  // Re-key the <use> on theme change so external-sprite icons painted with
  // `fill: currentColor` re-resolve their colour. Toggling the theme only
  // changes the CSS variable behind `currentColor`; the cloned shadow tree of
  // an external <use> doesn't reliably repaint on that alone, leaving the icon
  // stuck on the previous theme's colour while plain text updates correctly.
  const theme = useBoundStore(state => state.common.theme)
  return (
    <svg {...props}>
      <use key={theme} href={`/sprite.svg?v=${ICON_IDS.length}#${id}`} />
    </svg>
  )
}

export default Icon
